export enum CommunicationPreference {
  Subscribed = 'subscribed',
  Unsubscribed = 'unsubscribed',
  PendingVerification = 'subscriptionVerificationPending'
}
